"use strict";
/// <reference types="jquery"/>
/// <reference types="datatables.net"/>

Object.defineProperty(exports, "__esModule", { value: true });
require("datatables.net-bs4");
require("./initDatatable");
require("./initDatatableAdmin");
var FilterCheckBoxSettingsClass_1 = require("./FilterCheckBoxSettingsClass");
require("./datatables.inlineEdit");
$.datatablesTemplates = [];
$.extend($.fn.dataTable.defaults, {
    "language": {
        "processing": "Traitement en cours...",
        "search": "Rechercher&nbsp;:",
        "lengthMenu": "Afficher _MENU_ &eacute;l&eacute;ments",
        "info": "_START_ &agrave; _END_ sur _TOTAL_",
        "infoEmpty": "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment",
        "infoFiltered": "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
        "infoPostFix": "",
        "loadingRecords": "Chargement en cours...",
        "zeroRecords": "Aucun &eacute;l&eacute;ment &agrave; afficher",
        "emptyTable": "Aucune donn&eacute;e disponible dans le tableau",
        "paginate": {
            "first": "Premier",
            "previous": "Pr&eacute;c&eacute;dent",
            "next": "Suivant",
            "last": "Dernier"
        },
        "aria": {
            "sortAscending": ": activer pour trier la colonne par ordre croissant",
            "sortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
        }
    }
});
var filterChBOrRbMethod = function filterChBOrRbMethod(cells, datas, filterNames) {
    var valid = true;
    $.each(filterNames, function (i, filterName) {
        var colNum, settings;
        valid = false;
        $.each(cells, function (i, col) {
            var $col = $(col);
            if ($col.data("loadFilter") && $col.data("loadFilter") === filterName) {
                settings = $col.data(filterName) || new FilterCheckBoxSettingsClass_1.FilterCheckBoxSettings();
                colNum = i;
                return;
            }
        });
        if (colNum) {
            var $filter = $("[class^=chkb-" + filterName + "]"),
                val = datas && datas[colNum] ? datas[colNum].split(",") : [],
                nbreFiltre = $filter.length;
            if (settings.isFilterExist()) {
                var isChecked = $filter.length > 0 ? $filter.is(":checked") : settings.defaultValue;
                if (!isChecked || isChecked && val.length > 0) {
                    valid = true;
                }
            } else if (nbreFiltre === $filter.filter(function (c) {
                return $($filter[c]).is(":checked");
            }).length) {
                valid = true;
            } else {
                $.each($filter, function (i, chk) {
                    var $chk = $(chk);
                    if ($chk.is(":checked") && val.indexOf($chk.val()) !== -1) {
                        valid = true;
                        return;
                    }
                });
            }
            return valid;
        }
    });
    return valid;
};
$.fn.addCheckBoxFilter = function (titlePane, filterName, dtSettings, filterCheckBoxSettings) {
    var $container = $(this),
        settings = filterCheckBoxSettings || new FilterCheckBoxSettingsClass_1.FilterCheckBoxSettings();
    //Si les checkbox n'ont pas encore été créées
    if ($("input[class^=chkb-" + filterName + "]").length === 0) {
        var $labelDiv = $("<div class=\"d-inline-block ml-2\" style=\"vertical-align: text-top;\"/>"),
            $filterContainer = $(settings.filterContainerSelector),
            dataFilter = [],
            col;
        filterName = filterName.toLowerCase();
        //On récupère l'index de la colonne sur laquelle est le filtre
        $.each($("th", dtSettings.nTHead), function (i, el) {
            var $el = $(el);
            if ($el.data("load-filter") && $el.data("load-filter").split(",").indexOf(filterName) !== -1) {
                $el.data(filterName, settings);
                col = i;
                return;
            }
        });
        // si filtre classic, on récupère dans les données toutes les valeurs possibles pour ajouter
        // autant de checkbox que de valeurs, sinon on ajoute qu'une seule checkbox.
        if (!settings.isFilterExist()) {
            $.each(dtSettings.aoData, function (i, d) {
                var data = d._aData[col]["@data-search"];
                if (data) {
                    $.merge(dataFilter, data.split(",").filter(function (f) {
                        return dataFilter.indexOf(f) === -1;
                    }));
                }
            });
        } else {
            dataFilter.push("");
        }
        //Pour chaque valeur on ajoute une checkbox
        $.each(dataFilter, function (i, f) {
            var $divChk = $("<div />", {
                "class": " custom-control custom-checkbox"
            }),
                libelle = f ? f.toLowerCase() : "",
                $chk = $("<input/>", {
                type: "checkbox",
                "class": "chkb-" + filterName + (!settings.isFilterExist() ? "-" + libelle : "") + " custom-control-input ml-2 mr-1",
                value: f || filterName,
                checked: settings.defaultValue || "checked",
                name: libelle || filterName,
                id: libelle || filterName
            }),
                $customLbl = $("<label />", {
                "class": "custom-control-label",
                text: f || titlePane,
                for: libelle || filterName
            });
            $divChk.append($chk).append($customLbl);
            if ($filterContainer.length > 0) {
                $filterContainer.append($divChk);
            } else {
                $labelDiv.append($divChk);
            }
        });
        if (dataFilter.length > 0) {
            // Si il est précisé un conteneur pour les checkbox, on les met dedans
            if ($filterContainer.length === 0) {
                var $headerCol = $("div.dataTables_wrapper").addClass("row"),
                    $table = $headerCol.find("table:first"),
                    $filter = $("<div class=\"col-sm-12\"/>"),
                    $subDiv = $("<div class=\"dataTables_filter_custom\"/>"),
                    $label = $("<label/>");
                if (!settings.isFilterExist()) {
                    $label.append(titlePane);
                }
                $label.append($labelDiv);
                $subDiv.append($label);
                $filter.append($subDiv);
                var $prev = $table.prev();
                if ($prev.length > 0 && $prev.hasClass("clear")) {
                    $prev.prevAll().addClass("col-sm-12");
                    $prev.before($filter);
                } else {
                    $table.before($filter);
                }
            }
            //Initialisation de l'évènement pour le filtrage sur les checkbox
            $(document).off("change", "input[class^=chkb-" + filterName + "]").on("change", "input[class^=chkb-" + filterName + "]", function () {
                $container.data("datatable").draw();
            });
        }
    }
    $("div.dataTables_length > label", $container).css({
        width: "auto"
    });
    return $container;
};
$.fn.dataTable.ext.search.push(function (oSettings, aData, iDataIndex) {
    if ($(oSettings.nTable).data("loadFilter")) {
        var $table = $(oSettings.nTable),
            filters = $table.data("loadFilter"),
            filtersArray = filters ? $.map(filters.split(","), function (f) {
            return f.toLowerCase();
        }) : [];
        var valid = filterChBOrRbMethod(oSettings.nTHead.children[0].cells, aData, filtersArray);
        return valid;
    }
    return true;
});
$.extend($.fn.dataTable.ext.classes, {
    sWrapper: "dataTables_wrapper container-fluid dt-bootstrap4",
    sFilterInput: "form-control form-control-sm",
    sLengthSelect: "form-control custom-select",
    sProcessing: "datatable-processing",
    sPageButton: "paginate_button page-item",
    sLength: "d-inline-block dataTables_length ml-2",
    sPaging: "d-inline-block dataTables_paginate paging_simple_numbers",
    sInfo: "dataTables_info w-100 text-center mt-3"
});
$(".datatable:not(table):not(.not-by-default)").setDatatable();
$(".datatable-admin:not(table):not(.not-by-default)").setDatatableAdmin(null);
$(".datatable-simple").DataTable();


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Datatable/index.ts
// module id = 518
// module chunks = 0